<app-file-drop (filesSelected)="processFile($event)" [allowedTypes]="'image/*'"></app-file-drop>
